export const initialAbility = [
  {
    action: "manage",
    subject: "superadmin",
  },
  {
    action: "read",
    subject: "admin",
  },
  {
    action: "read",
    subject: "partner",
  },
];

export const _ = undefined;
